module.exports = __webpack_public_path__ + "static/img/second.78ccf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandLanshu/second.png
// module id = pS0U
// module chunks = 0